import "./scss/style.scss";
import React, { Suspense } from "react";
import Loader from "./views/common/Loader";
import { useIsMobile } from "./hooks/useIsMobile";

const WebApp = React.lazy(() => import("./web/WebApp"));
const MobileApp = React.lazy(() => import("./mobile/MobileApp"));

function App() {
  const isMobile = useIsMobile();
  return (
    <div className="App">
      <Suspense fallback={<Loader />}>
        {isMobile ? <MobileApp /> : <WebApp />}
      </Suspense>
    </div>
  );
}

export default App;
